import classnames from 'classnames'
import { useTranslation } from 'next-i18next'
import React from 'react'

import { ProductProperties } from '@src/telemetry/getProductPropertiesForTracking'

// Utils

import LoaderWrapper from '../../loaderWrapper'
import Pagination, { PaginationProps } from '../../pagination'
import { ReviewItem, ReviewItemProps } from '../reviewItem'

import styles from './allReviews.module.scss'
import { ReviewsFilter, ReviewsFilterProps } from './ReviewsFilter'

export interface AllReviewsProps {
  reviews: ReviewItemProps[]
  paginationProps: PaginationProps
  className?: string
  filterProps: ReviewsFilterProps
  showReviewsLoader?: boolean
  onReviewImageClick: (reviewId: number, imageIndex: number) => void
  isKidsAndBabyProduct?: boolean
  variants?: any
  productProperties: ProductProperties
  newPdpv2?: boolean
}

export const AllReviews = ({ className = '', ...props }: AllReviewsProps) => {
  const { t } = useTranslation('common')
  // if (props.reviews.length <= 0) return <ReviewsFilter {...props.filterProps} />;

  return (
    <div className={classnames(styles.allReviewWrap, className, props.newPdpv2 && styles.allReviewWrap_newPdpDesignV2)}>
      <ReviewsFilter
        {...props.filterProps}
        variants={props.variants}
        productProperties={props.productProperties}
        newPdpv2={props.newPdpv2}
      />
      <LoaderWrapper showLoader={props.showReviewsLoader}>
        {props.filterProps.hasPhoto && props.reviews.length <= 0 ? (
          <div className={styles.allReviews__noPhotoReviewText}>{t('no_reviews_with_photos')}</div>
        ) : (
          <div
            className={classnames(styles.reviewInnerWrap, {
              [styles.reviewInnerWrap_newPdpv2 ?? '']: props.newPdpv2,
            })}
          >
            {props.reviews.map((reviewItem: ReviewItemProps, index: number) => {
              return (
                <ReviewItem
                  key={index}
                  index={index + (props.paginationProps.page - 1) * 4}
                  {...reviewItem}
                  isKidsAndBabyProduct={props.isKidsAndBabyProduct}
                  onReviewImageClick={props.onReviewImageClick}
                  className={props.newPdpv2 ? styles.reviewItemWrap_newPdpv2 : ''}
                  newPdpv2={props.newPdpv2}
                />
              )
            })}
          </div>
        )}
      </LoaderWrapper>

      {props.reviews.length > 0 && <Pagination {...props.paginationProps} />}
    </div>
  )
}

export default AllReviews
